import React from "react";
import { AtomicTextField } from "@adsk/acc-issues-common/components/primitive/AtomicTextField";
import { useFieldTestId } from "../../../utils/components/IssueFieldPresentationContext";
import { isAttributeEditable } from "../../../utils/data/entityPermissions";
import { Issue } from "@adsk/acc-issues-types";
import { useTranslations } from "@adsk/acc-issues-translations";
import { useTextValidation } from "../../../utils/validation/validationUtils";
import { MAX_ISSUE_DESCRIPTION_LENGTH } from "../../../utils/validation/entitySchemas";
import { IssueChangeFn } from "./typesForFields";

// This Field is similar to the one in IssuesTab/TemplatesConfig/IssueTemplateDetailPanel/detail-panel-fields/...
// In case any necessary change is needed, it would be nice check on the other file as well
export const DescriptionField = ({
  T,
  handleChange,
  issue,
  required = false,
  viewOnly = false,
}: {
  T: ReturnType<typeof useTranslations>["T"];
  handleChange: IssueChangeFn;
  issue: Issue;
  required?: boolean;
  viewOnly?: boolean;
}) => {
  const testId = useFieldTestId("description-field");

  const validationSchema = useTextValidation({
    maxLength: MAX_ISSUE_DESCRIPTION_LENGTH,
    isRequired: required,
  });

  const isDisabled = viewOnly || !isAttributeEditable(issue, "description");

  return (
    <div data-testid={testId}>
      <AtomicTextField
        fieldKey="description"
        label={T.translate("issueAttributes.description")}
        value={issue.description || ""}
        onChange={newValue => {
          handleChange({
            description: newValue,
          });
        }}
        validator={text => {
          try {
            validationSchema.validateSync(text);
          } catch (error: any) {
            return error.message;
          }
        }}
        disabled={isDisabled}
        isMultiLine
        required={required}
        showDisabledReason={!viewOnly}
      />
    </div>
  );
};
